<template>
    <div class="cont-result-faq margin-general">
        <NuxtLink :to="localPath('/faq')" class="back-link">
            <span data-v-b04161ba="" class="material-symbols-outlined" translate="no">chevron_left</span>
            {{ $t("faq.goback") }}
        </NuxtLink>
        <div class="sub-cont">
            <FaqAccordion>
                <div class="accordeon container movil">
                    <div class="content-main-tab">
                        <div class="tab-content">
                            <div class="contet-general">
                                <h4 role="heading" aria-level="1">{{ $t("faq.tab30.title1") }}</h4>
                                <div class="icon-text">
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab30.text1") }}</span></p>
                                        <div class="buttons sub-cont">
                                        <a target="_blank" :href="getExternalUrl('/register/1/live-account')" rel="noopener noreferrer">
                                            <button class="primary-button-medium">{{ $t("faq.tab30.btn") }}</button>
                                        </a>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FaqAccordion>
            <div class="accordeon container destock">
                    <div class="content-main-tab">
                    <div class="tab-content">
                        <div class="contet-general">
                            <h1>{{ $t("faq.tab30.title1") }}</h1>
                            <div class="icon-text">
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab30.text1") }}</span></p>
                                    <div class="buttons sub-cont">
                                    <a target="_blank" :href="getExternalUrl('/register/1/live-account')" rel="noopener noreferrer">
                                        <button class="primary-button-medium">{{ $t("faq.tab30.btn") }}</button>
                                    </a>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
import FaqAccordion from '~/components/faq/FaqAccordion.vue'
import { useExternalUrl } from '@/composables/useExternalUrl';
const { getExternalUrl } = useExternalUrl();
const { t } = useI18n();
const localPath = useLocalePath();
useFaqSeoMeta("faq.tab30.title1", "faq.tab30.text1");
</script>
